<template>
  <div>
    <recharge-mess v-transition></recharge-mess>
  </div>
</template>

<script>
import RechargeMess from './components/Mess'
export default {
  name: 'Recharge',
  components: {
    RechargeMess
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/recharge/Recharge.vue